import type { IconData } from '@stacksjs/iconify-core'

export const travelGlobe: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14.634 12.473A8 8 0 1 0 1.367 3.527a8 8 0 0 0 13.267 8.946M2 8c0 1.657.672 3.157 1.757 4.243L8 8zm9 1l2.124 2.124a6 6 0 0 0-6.052-9.052L11 6z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default travelGlobe
